// Stage identity stays separate from payloads sent to the task editors.
export const collectWorkspaceTasks = (hire) => Object.entries(hire?.tasks || {}).flatMap(([stage, data]) => {
  const workflow = Object.entries(data?.workflow?.tasks || {});
  const legacy = Object.entries(data || {}).filter(([id, task]) => id !== 'workflow' && task?.title && !data?.workflow?.tasks?.[id]);
  return [...workflow, ...legacy].map(([id, task]) => ({ key: `${stage}:${id}`, stage, task: { ...task, id } }));
});

export const taskDateKey = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const taskState = (task, today) => {
  if (task.status === 'completed') return 'completed';
  if (task.status === 'failed' || task.status === 'error') return 'failed';
  const due = taskDateKey(task.dueDate);
  if (due && due < today) return 'overdue';
  if (due === today) return 'today';
  return task.status === 'in_progress' ? 'inProgress' : 'pending';
};

export const filterWorkspaceTasks = (entries, { stage = 'all', status = 'open', query = '', owner = 'all', today, ownerLabel, isMine }) => {
  const search = query.trim().toLocaleLowerCase();
  return entries.filter(entry => {
    const { task } = entry;
    const state = taskState(task, today);
    return (stage === 'all' || entry.stage === stage)
      && (status === 'all' || (status === 'open' ? state !== 'completed' : state === status))
      && (owner === 'all' || (owner === '__mine' ? isMine(task) : ownerLabel(task) === owner))
      && (!search || `${task.title || ''} ${task.description || ''} ${ownerLabel(task)}`.toLocaleLowerCase().includes(search));
  }).sort((a, b) => {
    const ranks = { failed: 0, overdue: 1, today: 2, inProgress: 3, pending: 3, completed: 4 };
    return ranks[taskState(a.task, today)] - ranks[taskState(b.task, today)]
      || (taskDateKey(a.task.dueDate) || '9999').localeCompare(taskDateKey(b.task.dueDate) || '9999')
      || String(a.task.title || '').localeCompare(String(b.task.title || ''));
  });
};
